import React from 'react';
import { motion } from 'framer-motion';
import { personalInfo } from '../data/portfolio';
import { Github, Linkedin, Mail, Code2, ArrowUp } from 'lucide-react';
import ParticleField from './ParticleField';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="relative py-12 px-6 md:px-12 border-t border-border/40">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, hsl(var(--primary) / 0.05) 0%, transparent 60%)' }}
      />
      
      <ParticleField />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Brand */}
          <a href="#">
          <div className="flex items-center gap-3">
           <img src="logo/logo.png" style={{ width:30, height:30 }} alt="Rajib Logo" />
            <div>
              <span className="font-heading font-semibold text-foreground text-sm">
                rajibr<span className="gradient-text">.com</span>
              </span>
              <p className="text-muted-foreground text-xs">Technical Lead · Automation Architect</p>
            </div>
          </div>
          </a>

          {/* Quick nav */}
          <div className="hidden md:flex items-center gap-6">
            {['About', 'Skills', 'Projects', 'Apps', 'Experience', 'Life', 'Contact'].map((link) => (
              <button
                key={link}
                onClick={() => {
                  const el = document.querySelector(`#${link.toLowerCase()}`);
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-muted-foreground text-sm hover:text-primary transition-colors duration-200"
              >
                {link}
              </button>
            ))}
          </div>

          {/* Social + back to top */}
          <div className="flex items-center gap-4">
            <a href={personalInfo.github} target="_blank" rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors duration-200">
              <Github size={18} />
            </a>
            <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors duration-200">
              <Linkedin size={18} />
            </a>
            <a href={`mailto:${personalInfo.email}?subject=Let's%20Connect%20Rajib&body=Hi%20Rajib,%0A%0AI%20came%20across%20your%20portfolio%20and%20would%20love%20to%20connect.%0A`}
              className="text-muted-foreground hover:text-primary transition-colors duration-200">
              <Mail size={18} />
            </a>
            <button
              onClick={scrollToTop}
              className="ml-2 w-8 h-8 glass rounded-lg flex items-center justify-center text-muted-foreground hover:text-primary transition-colors duration-200"
            >
              <ArrowUp size={15} />
            </button>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-border/30 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-muted-foreground text-xs">
            © 2026 Rajib Roy · <a href="https://rajibr.com" className="gradient-text hover:opacity-80 transition-opacity">rajibr.com</a>. Built with{' '}
            <span className="gradient-text font-medium">React + Framer Motion</span>.
          </p>
          <p className="text-muted-foreground text-xs font-mono">
            Toronto, ON · <a href={`mailto:${personalInfo.email}?subject=Let's%20Connect%20Rajib&body=Hi%20Rajib,%0A%0AI%20came%20across%20your%20portfolio%20and%20would%20love%20to%20connect.%0A`}>bboyrajib@gmail.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
